import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CashDrawerDTO, CashDrawerRegistrationForm } from '../../../types/hardware/CashDrawerTypes';
import { EntityStateDTO } from '../../../types/common/EntityStateDTO';

interface CashDrawerState {
  form: CashDrawerRegistrationForm;
  list: CashDrawerDTO[];
  isSubmitting: boolean;
  error: string | null;
  showRegistrationModal: boolean;
  showEditModal: boolean;
}

const initialState: CashDrawerState = {
  form: {
    name: '',
    printerId: null,
    openCommand: '',
  },
  list: [],
  isSubmitting: false,
  error: null,
  showRegistrationModal: false,
  showEditModal: false,
};

const cashDrawerSlice = createSlice({
  name: 'cashDrawer',
  initialState,
  reducers: {
    setSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setCashDrawerList(state, action: PayloadAction<CashDrawerDTO[]>) {
      state.list = action.payload;
    },
    setCashDrawerForm(state, action: PayloadAction<CashDrawerRegistrationForm>) {
      state.form = action.payload;
      state.error = null;
    },
    updateCashDrawerField(
      state,
      action: PayloadAction<{ field: keyof CashDrawerRegistrationForm; value: any }>
    ) {
      const { field, value } = action.payload;
      state.form = {
        ...state.form,
        [field]: value,
      };
    },
    resetCashDrawerForm(state) {
      state.form = initialState.form;
      state.isSubmitting = false;
      state.error = null;
    },
    setShowRegistrationModal(state, action: PayloadAction<boolean>) {
      state.showRegistrationModal = action.payload;
    },
    setShowEditModal(state, action: PayloadAction<boolean>) {
      state.showEditModal = action.payload;
    },
    closeRegistrationModalAndReset(state) {
      state.showRegistrationModal = false;
      state.form = initialState.form;
      state.isSubmitting = false;
      state.error = null;
    },
    closeEditModalAndReset(state) {
      state.showEditModal = false;
      state.form = initialState.form;
      state.isSubmitting = false;
      state.error = null;
    },
    updateCashDrawerStatus(state, action: PayloadAction<EntityStateDTO>) {
      const { id, active } = action.payload;
      const index = state.list.findIndex(drawer => drawer.id === id);
      if (index !== -1) {
        state.list[index].active = active;
      }
    },
  },
});

export const {
  setSubmitting,
  setError,
  setCashDrawerList,
  setCashDrawerForm,
  updateCashDrawerField,
  resetCashDrawerForm,
  setShowRegistrationModal,
  setShowEditModal,
  closeRegistrationModalAndReset,
  closeEditModalAndReset,
  updateCashDrawerStatus,
} = cashDrawerSlice.actions;

export default cashDrawerSlice.reducer;
